import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import { connect } from 'react-redux';
import _get from 'lodash.get';
//import VideoTheaterSlider from 'routes/articleshow/components/VideoTheater/VideoTheaterSlider';
import WithVideoTheaterSlider from 'routes/articleshow/components/VideoTheater/WithVideoTheaterSlider';
import exitFullscreen from 'utils/fullScreen';
import {
  shouldShowVideoBlocker,
  fetchUserSubscriptionStatusFromApi,
  isPrcNotSet,
} from 'utils/primeUtil';
import startVideoPlayer from 'components/Player';
import { gaWrapper } from 'helpers/analytics';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  deleteUnDockCandidate,
  deleteDockCandidate,
} from 'routes/articleshow_v2/redux';
import VideoBlocker from './VideoBlocker';
// import { jQueryFn } from '../../utils/polyfills';
import { pausePlayer, destroyPlayer } from './utils';
// eslint-disable-next-line no-unused-vars
import s from './VideoBlocker.scss';

class Video extends React.Component {
  static propTypes = {
    msid: PropTypes.string,
    chapterId: PropTypes.string,
    imgsize: PropTypes.string,
    slikeId: PropTypes.string,
    videoClassName: PropTypes.string,
    videoClassInner: PropTypes.string,
    theatreModeClassName: PropTypes.string,
    title: PropTypes.string,
    // rmid: PropTypes.string,
    livetv: PropTypes.bool,
    autoplay: PropTypes.bool,
    outsideEventListener: PropTypes.func,
    nextVideoMsidArray: PropTypes.arrayOf(PropTypes.string),
    store: PropTypes.shape({}),
    userData: PropTypes.shape({
      prcValue: PropTypes.string,
    }).isRequired,
    iconClassName: PropTypes.string,
    isPrime: PropTypes.bool,
    isUserPrime: PropTypes.bool,
    isContentPrime: PropTypes.bool,
    pos: PropTypes.string,
    playerContainerId: PropTypes.string,
    isVideoSkipAds: PropTypes.bool,
    isDockingEnabled: PropTypes.bool,
    addToWatched: PropTypes.func,
    isDocked: PropTypes.bool,
    source: PropTypes.string,
    allowDim: PropTypes.bool,
    videoRef: PropTypes.shape({}).isRequired,
    slikeNextVideoAutoPlayed: PropTypes.bool,
    dockedClassName: PropTypes.string,
    // eslint-disable-next-line react/no-unused-prop-types
    deleteDockCandidate: PropTypes.func,
    // eslint-disable-next-line react/no-unused-prop-types
    deleteUnDockCandidate: PropTypes.func,
    dockTitle: PropTypes.string,
    isLeadVideo: PropTypes.bool,
    videoTheatreSliderData: PropTypes.arrayOf({}),
    videoPlayListData: PropTypes.arrayOf({}),
    isVideoTheatreMinified: PropTypes.bool,
    videoDataReceivedCallback: PropTypes.func,
    asyncLoadSdkjs: PropTypes.bool,
    isWapView: PropTypes.bool,
    iphonefs: PropTypes.bool,
    duration: PropTypes.string,
    isInline: PropTypes.bool,
    sectionName: PropTypes.string,
    isMute: PropTypes.bool,
    dontChangeDivId: PropTypes.bool,
    agency: PropTypes.string,
    hideControls: PropTypes.bool,
    playerType: PropTypes.string,
    videoInloop: PropTypes.bool,
    titleStr: PropTypes.string,
    videoDocked: PropTypes.bool,
    videoTitle: PropTypes.string,
    closeDockedVideo: PropTypes.func,
    playPauseDockedVideo: PropTypes.func,
    playState: PropTypes.bool,
    updateplayerConfig: PropTypes.shape({}),
    tmplSource: PropTypes.string,
    scrollAutoPlay: PropTypes.bool,
    scrollAutoPause: PropTypes.bool,
    isVideoshow: PropTypes.bool,
    dockedPlayerMobileClass: PropTypes.string,
    isEtimes: PropTypes.bool,
    deleteUnDockCandidateAction: PropTypes.func,
    deleteDockCandidateAction: PropTypes.func,
    metakeywords: PropTypes.string,
  };
  static defaultProps = {
    livetv: false,
    autoplay: false,
    title: '',
    msid: '',
    chapterId: undefined,
    imgsize: '123456',
    videoClassName: '',
    videoClassInner: '',
    theatreModeClassName: '',
    slikeNextVideoAutoPlayed: false,
    // rmid: '',
    outsideEventListener: undefined,
    nextVideoMsidArray: [],
    videoPlayListData: [],
    store: {},
    // rmid: '',
    slikeId: undefined,
    iconClassName: '',
    pos: '0',
    isPrime: false,
    isUserPrime: false,
    isContentPrime: false,
    playerContainerId: '',
    isVideoSkipAds: false,
    isDockingEnabled: false,
    isDocked: false,
    source: 'videoshow',
    allowDim: true,
    dockedClassName: '',
    deleteDockCandidate: undefined,
    deleteUnDockCandidate: undefined,
    dockTitle: '',
    isLeadVideo: false,
    videoTheatreSliderData: undefined,
    isVideoTheatreMinified: false,
    addToWatched: undefined,
    videoDataReceivedCallback: undefined,
    asyncLoadSdkjs: false,
    isWapView: false,
    iphonefs: false,
    duration: '',
    isInline: false,
    sectionName: '',
    isMute: false,
    dontChangeDivId: false,
    agency: '',
    hideControls: false,
    playerType: '',
    titleStr: '',
    videoInloop: false,
    videoDocked: false,
    videoTitle: '',
    closeDockedVideo: undefined,
    playPauseDockedVideo: undefined,
    playState: true,
    updateplayerConfig: {},
    tmplSource: '',
    scrollAutoPlay: true,
    scrollAutoPause: true,
    isVideoshow: false,
    dockedPlayerMobileClass: '',
    isEtimes: false,
    deleteUnDockCandidateAction: () => {},
    deleteDockCandidateAction: () => {},
    metakeywords: '',
  };
  constructor(props) {
    super(props);
    this.isPlaying = false;
    this.primeEndDate = '';
    this.slikeInstance = null;
    this.state = {
      isVideoPlaying: false,
      isLeadVideoTheatreOpen: false,
      activeSlide: props.msid,
      playingVideoItem: undefined,
      showVideoBlocker: false,
    };
    this.intantiateNewPlayer = true;
  }

  componentDidMount() {
    if (this.props.autoplay) {
      this.startVideo(
        this.props.msid,
        this.getDivId(this.props.msid, this.props.isInline),
        this.props.chapterId,
      );
      this.isPlaying = true;
    }
    // debugger;
    // window.addEventListener(
    //   'onVideoProgress',
    //   () => {
    //     this.showProgress();
    //   },
    //   false,
    // );

    // const jQueryPolyfill = jQueryFn();
    // window.$ = window.$ || jQueryPolyfill.$;
    // window.jQuery = window.jQuery || jQueryPolyfill.jQuery;
  }

  // showProgress = (data) => {
  //   console.log('video progres', data);
  // }

  componentWillUnmount() {
    destroyPlayer();
  }

  componentDidUpdate(prevProps, prevState) {
    const { videoContainer } = this;
    const { userData, isContentPrime } = this.props;
    const { prcValue } = userData;

    if (
      (prevProps.userData && prevProps.userData.prcValue !== prcValue) ||
      prevProps.msid !== this.props.msid
    ) {
      if (!isContentPrime || !shouldShowVideoBlocker(prcValue)) {
        this.mute(false);
      }
    }

    // Typical usage (don't forget to compare props):
    if (
      this.props.msid !== prevProps.msid &&
      !this.props.slikeNextVideoAutoPlayed
    ) {
      this.isPlaying = false;
      if (videoContainer && videoContainer.innerHTML) {
        videoContainer.innerHTML = '';
      }
      this.startVideo(
        this.props.msid,
        this.getDivId(this.props.msid, this.props.isInline),
      );
    }

    if (prevState.activeSlide !== this.state.activeSlide) {
      this.startVideo(
        this.state.activeSlide,
        this.getDivId(this.props.playerContainerId, this.props.isInline),
      );
    }

    if (
      prevState.isLeadVideoTheatreOpen !== this.state.isLeadVideoTheatreOpen
    ) {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = this.state.isLeadVideoTheatreOpen ? 'hidden' : '';
    }

    if (prevProps.userPrcData !== this.props.userPrcData) {
      this.processPrimeBlocker();
    }
  }

  handleSliderCardItem = (e, clickedVideoItem) => {
    e.preventDefault();
    this.setState({
      playingVideoItem: clickedVideoItem,
      activeSlide: clickedVideoItem.id,
    });
  };

  videoEventsListener = (eventOrigin, eventObj) => {
    const eventData = eventObj instanceof Array ? eventObj[0] : '';
    const eventName = eventObj[1];
    this.pauseVideoInPrimeBlocker(eventName, eventData);
    if (typeof this.props.outsideEventListener === 'function') {
      this.props.outsideEventListener(eventOrigin, eventObj);
    }
  };

  showPrimeBlocker = (data = {}) => {
    this.primeEndDate = data.data && data.data.endDate ? data.data.endDate : '';
    this.setState({
      showVideoBlocker: true,
    });
    exitFullscreen();
  };

  processPrimeBlocker = () => {
    const { userData, isContentPrime } = this.props;
    const { isLoggedIn, prcValue } = userData;
    if (isContentPrime && shouldShowVideoBlocker(prcValue)) {
      if (isLoggedIn && !isPrcNotSet(prcValue)) {
        fetchUserSubscriptionStatusFromApi(this.props.userPrcData).then(
          data => {
            this.showPrimeBlocker(data);
          },
        );
      } else {
        this.showPrimeBlocker({});
      }
    } else {
      this.setState({
        showVideoBlocker: false,
      });
    }

    return isContentPrime;
  };

  pauseVideoInPrimeBlocker = () => {
    const { userData, isContentPrime } = this.props;
    const { prcValue } = userData;
    if (shouldShowVideoBlocker(prcValue) && isContentPrime) {
      this.pause();
      this.mute(true);
    }
  };

  mute = shouldMute => {
    // console.log('slikee..', this.slikeInstance);
    if (this.slikeInstance && typeof this.slikeInstance.mute === 'function') {
      try {
        this.slikeInstance.mute(shouldMute);
      } catch (e) {
        // console.log(e);
      }
    }
  };

  pause = () => {
    if (this.slikeInstance && typeof this.slikeInstance.pause === 'function') {
      this.slikeInstance.pause();
    }
  };

  resumePlay = () => {
    if (this.slikeInstance && typeof this.slikeInstance.play === 'function') {
      this.slikeInstance.play();
    }
  };

  playVideo = () => {
    if (window && window.player && window.player.length > 0) {
      window.player.forEach((item, index) => {
        if (item.store.clientConfig.contEl === this.props.playerContainerId) {
          window.player[index].play();
          if (
            this.props.resumeDockedVideoCallBack &&
            typeof this.props.resumeDockedVideoCallBack === 'function'
          ) {
            this.props.resumeDockedVideoCallBack();
          }
        }
      });
    }
  };

  hideBlockerAndResume = response => {
    if (!response.status) {
      return;
    }
    this.setState({
      showVideoBlocker: false,
    });
    this.resumePlay();
  };

  getPlayListObject = data => {
    const finalObject = [];
    if (data && Array.isArray(data) && data.length > 0) {
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].playerId || data[i].embedId) {
          finalObject.push({ embedId: data[i].playerId || data[i].embedId });
        }
      }
    }
    return finalObject;
  };

  startVideo = (msid, divId, chapterId) => {
    this.isPlaying = true;
    const { toipLayout, shareUrl } = this.props;
    if (toipLayout) {
      const prevMsid = sessionStorage.getItem('prevMsid');
      if (msid !== prevMsid) {
        pausePlayer();
      }
    }

    const { userData, sectionName, isMute = false } = this.props;
    const { prcValue } = userData;
    if (this.props.newga && typeof this.props.newga === 'string') {
      gaWrapper('send', 'event', ...this.props.newga.split('#'));
    }
    if (
      typeof this.addNextVideoToList === 'function' &&
      !this.intantiateNewPlayer &&
      this.props.slikeId
    ) {
      this.addNextVideoToList(
        msid,
        this.props.slikeId,
        this.props.playerType,
        shareUrl,
        this.props.metakeywords,
      );
    } else {
      this.addNextVideoToList = startVideoPlayer({
        videoMsid: msid,
        divId,
        outsideEventListener: this.videoEventsListener,
        nextVideoMsidArray: this.props.nextVideoMsidArray,
        playlistData: this.getPlayListObject(
          this.props.videoPlayListData || [],
        ),
        store: this.props.store,
        isPrime: this.props.isPrime,
        isUserPrime: this.props.isUserPrime,
        slikeId: this.props.slikeId,
        playerType: this.props.playerType,
        livetv: this.props.livetv,
        isVideoSkipAds: this.props.isVideoSkipAds,
        isDockingEnabled: this.props.isDockingEnabled,
        addToWatched: this.props.addToWatched,
        sourceVal: this.props.source || 'videoshow',
        allowDimVal: this.props.allowDim,
        shouldShowVideoBlocker,
        prcValue,
        isWapView: this.props.isWapView,
        autoPlayLeadVideo: this.props.autoPlayLeadVideo,
        callback: () => {
          // this.setState({ videoLoaded: true });
        },
        callbackOutside: inst => {
          this.slikeInstance = inst;
        },
        muteOnLoad: isMute,
        videoDataReceivedCallback: this.props.videoDataReceivedCallback,
        asyncLoadSdkjs: this.props.asyncLoadSdkjs,
        videoChapterId: chapterId,
        iphonefs: this.props.iphonefs,
        sectionName,
        intantiateNewPlayer: this.intantiateNewPlayer,
        ag: this.props.agency,
        hideControls: this.props.hideControls,
        videoInloop: this.props.videoInloop,
        titleStr: this.props.titleStr,
        shareUrl: this.props.shareUrl,
        headless: this.props.headless,
        videoProgressCallback: this.props.videoProgressCallback,
        updateplayerConfig: this.props.updateplayerConfig,
        tmplSource: this.props.tmplSource,
        scrollAutoPlay: this.props.scrollAutoPlay,
        scrollAutoPause: this.props.scrollAutoPause,
        isVideoshow: this.props.isVideoshow,
        isEtimes: this.props.isEtimes,
        metakeywords: this.props.metakeywords,
        bl: this.props.bl,
      });
    }

    this.intantiateNewPlayer = false;

    if (toipLayout) {
      sessionStorage.setItem('prevMsid', msid);
    }
    this.setState({ isVideoPlaying: true });
  };

  getDivId(playerContainerId, isInline) {
    if (
      !this.props.dontChangeDivId &&
      playerContainerId &&
      playerContainerId.length
    ) {
      return `playerContainer_${playerContainerId}${isInline ? '_inline' : ''}`;
    }
    return `playerContainer`;
  }
  render() {
    const {
      msid,
      imgsize,
      videoClassName,
      videoClassInner,
      dockedClassName,
      theatreModeClassName,
      title,
      autoplay,
      iconClassName,
      isPrime,
      isDocked,
      dockTitle,
      isLeadVideo,
      duration,
      toipLayout,
      videoDocked,
      videoTitle,
      playState,
      playPauseDockedVideo,
      dockedPlayerMobileClass,
    } = this.props;
    // mobile code start<b
    const divId = this.getDivId(this.props.msid, this.props.isInline);
    const currTitle =
      this.state.playingVideoItem && this.state.playingVideoItem.hl
        ? this.state.playingVideoItem.hl
        : dockTitle;

    // mobile code end

    return (
      <div
        ref={this.props.videoRef}
        className={`${videoClassName} ${dockedClassName} ${dockedPlayerMobileClass} ${
          this.state.isLeadVideoTheatreOpen ? theatreModeClassName : ''
        }`}
      >
        {isDocked &&
          !this.props.isWapView && (
            <div className="dockHeader">
              <div className="docktop">
                {isPrime && <span className={s.now_playing}>Now Playing</span>}
                {!isPrime &&
                  isLeadVideo && (
                    <button
                      type="button"
                      className="dockicon"
                      onClick={() => {
                        this.setState({
                          isLeadVideoTheatreOpen: !this.state
                            .isLeadVideoTheatreOpen,
                        });
                      }}
                    />
                  )}
                <button
                  type="button"
                  className={`closedock ${
                    toipLayout ? s.closeVideoButton : ''
                  }`}
                  onClick={() => {
                    this.setState({
                      isLeadVideoTheatreOpen: false,
                    });
                    if (typeof deleteUnDockCandidate === 'function') {
                      this.props.deleteUnDockCandidateAction();
                      deleteUnDockCandidate();
                    }
                    if (typeof deleteDockCandidate === 'function') {
                      this.props.deleteDockCandidateAction();
                      deleteDockCandidate();
                    }
                    pausePlayer();
                  }}
                />
              </div>
              {isPrime && <div className="title c1">{dockTitle}</div>}
            </div>
          )}
        {this.props.isWapView &&
          videoDocked && (
            <div className="videoAction">
              <button
                type="button"
                className={`playPause ${playState ? `play` : `pause`}`}
                onClick={() => playPauseDockedVideo()}
              />
            </div>
          )}
        {videoDocked && (
          <button
            type="button"
            className="closeDoc"
            onClick={() => this.props.closeDockedVideo()}
          />
        )}
        <div
          onClick={() => {
            if (!autoplay && !this.playerInitiated) {
              this.playerInitiated = true;
              this.startVideo(msid, divId);
            }
          }}
          id={divId}
          data-pos={this.props.pos}
          className={`${videoClassInner}`}
          style={{
            height: '100%',
          }}
        >
          {title && (
            <p>
              <b>{title}</b>
            </p>
          )}
          {!this.state.isVideoPlaying &&
            !autoplay && (
              <>
                <Image
                  msid={msid}
                  src={`https://static.toiimg.com/photo/${msid}.cms`}
                  // width={width}
                  title={title}
                  imgsize={imgsize || ''}
                  imageClassName="d"
                  placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
                  lazyload
                />
                {iconClassName && (
                  <i className={iconClassName || ''}>
                    {typeof duration === 'string' ? duration : ''}
                  </i>
                )}
              </>
            )}
        </div>
        {videoDocked && (
          <div className="vid_title">
            <strong>Now Playing</strong>
            <span>{videoTitle}</span>
          </div>
        )}
        {this.state.showVideoBlocker && (
          <VideoBlocker
            isVideoTheatreMinified={this.props.isVideoTheatreMinified}
            msid={msid}
            imgsize={imgsize}
            primeEndDate={this.primeEndDate}
            hideBlockerAndResume={this.hideBlockerAndResume}
            prc={this.props.userData.prcValue}
          />
        )}
        {!isPrime &&
          isDocked &&
          !this.props.isWapView && (
            <div className="vid_title">
              {' '}
              <strong>Now Playing</strong>
              <span>{currTitle}</span>
            </div>
          )}
        {isDocked &&
          this.props.isWapView &&
          this.props.dockedPlayerMobileClass &&
          this.props.dockedPlayerMobileClass === 'mweb_as_dock' &&
          !this.props.isInline && (
            <div className="mobile_dock_container" onClick={this.playVideo}>
              {/* <div className="img_container" onClick={this.playVideo}>
                <Image
                  msid={msid}
                  src={`https://static.toiimg.com/thumb/msid-${msid},imgsize-${imgsize},width-400,resizemode-4/${msid}.jpg`}
                  imgsize={imgsize}
                  // imageClassName={}
                  placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
                  lazyload
                  // altTitle={video.hl ? video.hl : ''}
                  // title={video.hl ? video.hl : ''}
                />
                <i className="playicon" />
              </div> */}
              <div className="vid_title_mobile">
                <h2>Now Playing</h2>
                <h3>{currTitle}</h3>
              </div>
              {!!this.props.dockTimerCountdown &&
                this.props.dockTimerCountdown > 0 && (
                  <div className="countdownContainer">
                    <span className="countText">
                      {this.props.dockTimerCountdown}
                    </span>
                  </div>
                )}
              <button
                type="button"
                className="closeDoc"
                onClick={() => {
                  if (typeof deleteUnDockCandidate === 'function') {
                    this.props.deleteUnDockCandidateAction();
                    deleteUnDockCandidate();
                  }
                  if (typeof deleteDockCandidate === 'function') {
                    this.props.deleteDockCandidateAction();
                    deleteDockCandidate();
                  }
                  pausePlayer();
                }}
              />
            </div>
          )}
        {!isPrime &&
          isLeadVideo &&
          this.state.isLeadVideoTheatreOpen && (
            <WithVideoTheaterSlider
              items={this.props.videoTheatreSliderData}
              handleSliderCardItem={this.handleSliderCardItem}
              activeSlide={this.state.activeSlide}
            />
          )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  deleteUnDockCandidateAction: () => {
    dispatch(deleteUnDockCandidate());
  },
  deleteDockCandidateAction: () => {
    dispatch(deleteDockCandidate());
  },
});

const mapStateToProps = state => ({
  userData: _get(state, 'login.userData', {}),
  isWapView: _get(state, 'isMobile', false),
  userPrcData: state.login?.userPrcData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Video);
